import {Reducers} from './dataEnum';

export const AppActionType = {
  SET_USER: 'SET_USER',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_MENU: 'SET_MENU',
  LOGOUT: 'LOGOUT',
  SET_SW_VERSION: 'SET_SW_VERSION',
  SET_IS_SAVING_REVIEW: 'SET_IS_SAVING_REVIEW',
  SET_CURRENT_PERIOD_ID: 'SET_CURRENT_PERIOD_ID',
  SET_CONSOLIDATION_STATUS: 'SET_CONSOLIDATION_STATUS',
};

export const AlertModalActionType = {
  SET_ALERT: 'SET_ALERT',
};

export const ManageEmployeeStateActions = {
  SET_DEPARTMENTS: 'SET_DEPARTMENTS',
  SET_PRACTICES: 'SET_PRACTICES',
  SET_AUTH_ROLES: 'SET_AUTH_ROLES',
  SET_ROLE_LEVELS: 'SET_ROLE_LEVELS',
  SET_COMPANIES: 'SET_COMPANIES',
  SET_NEW_EMPLOYEE: 'SET_NEW_EMPLOYEE',
  SET_NEW_EMPLOYEE_BY_KEY: 'SET_NEW_EMPLOYEE_BY_KEY',
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  SET_MODAL_TYPE: 'SET_MODAL_TYPE',
  SET_SORT_VALUE: 'SET_SORT_VALUE',
  SET_FILTER_MAP: 'SET_FILTER_MAP',
  SET_PAGE_SIZE: 'SET_PAGE_SIZE',
  SET_PAGE_NO: 'SET_PAGE_NO',
  SET_PAGE_INDEX: 'SET_PAGE_INDEX',
  SET_TOTAL_ITEM: 'SET_TOTAL_ITEM',
  SET_RESPONSE_STATUS: 'SET_RESPONSE_STATUS',
  SET_EMPLOYEES: 'SET_EMPLOYEES',
  RESET_NEW_EMPLOYEE: 'RESET_NEW_EMPLOYEE',
  SET_SELECTED_TAB: 'SET_SELECTED_TAB',
  RESET_STATE: 'RESET_STATE',
  SET_INITIAL_STATE: 'SET_INITIAL_STATE',
};

export const TeamAssignmentStateActions = {
  SET_DATE: 'SET_DATE',
  SET_AVAILABLE_EMPLOYEE: 'SET_EMPLOYEE',
  SET_ASSIGNED_EMPLOYEE: 'SET_ASSIGNED_EMPLOYEE',
  SET_EMPLOYEE_ID_TO_ROLE_CHANGE: 'SET_EMPLOYEE_ID_TO_ROLE_CHANGE',
  SET_EMPLOYEE_ID_TO_ASSIGN: 'SET_EMPLOYEE_ID_TO_ASSIGN',
  SET_PROJECTS: 'SET_PROJECTS',
  SET_SELECTED_PROJECT: 'SET_SELECTED_PROJECT',
  SET_TEAM_PROJECT: 'SET_TEAM_PROJECT',
  SET_SHOW_MODAL_TEAM: 'SET_SHOW_MODAL_TEAM',
  SET_SHOW_MODAL_DATE_PICKER: 'SET_SHOW_MODAL_DATE_PICKER',
  SET_HISTORY_DATA: [Reducers.TEAM_ASSIGNMENT, 'SET_ALL_DEPARTMENTS'].join("/"),  
  SET_HISTORY_LOADING: [Reducers.TEAM_ASSIGNMENT, 'SET_HISTORY_LOADING'].join("/"),  
  SET_TEAM_ASSIGNMENT_LOADING: [Reducers.TEAM_ASSIGNMENT, 'SET_TEAM_ASSIGNMENT_LOADING'].join('/'),
  SET_ALL_DEPARTMENTS: 'SET_ALL_DEPARTMENTS',
  SET_PERIODS: 'SET_PERIODS',
  SET_SAVE_ASSIGN_BUTTON: 'SET_SAVE_ASSIGN_BUTTON',
  SET_SELECTED_PERIOD: 'SET_SELECTED_PERIOD',
  RESET_STATE_TEAM_ASSIGNMENT: 'RESET_STATE_TEAM_ASSIGNMENT',
  SET_EMPLOYEE_ID_TO_REMOVE: 'SET_EMPLOYEE_ID_TO_REMOVE',
};

export const practiceStateActions = {
  SET_PRACTICES: [Reducers.PRACTICE, 'SET_PRACTICES'].join('/'),
  SET_SELECTED_PRACTICE: [Reducers.PRACTICE, 'SET_SELECTED_PRACTICE'].join('/'),
  RESET_PRACTICE: [Reducers.PRACTICE, 'RESET_PRACTICE'].join('/'),
};

export const departmentStateActions = {
  SET_DEPARTMENTS: [Reducers.DEPARTMENT, 'SET_DEPARTMENTS'].join('/'),
  SET_SELECTED_DEPARTMENT: [Reducers.DEPARTMENT, 'SET_SELECTED_DEPARTMENT'].join('/'),
  SET_IS_DEPARTMENT_READY: [Reducers.DEPARTMENT, 'SET_IS_DEPARTMENT_READY'].join('/'),
};

export const periodStateActions = {
  SET_PERIODS: [Reducers.PERIOD, 'SET_PERIODS'].join('/'),
  SET_SELECTED_PERIOD: [Reducers.PERIOD, 'SET_SELECTED_PERIOD'].join('/'),
  RESET_SELECTED_PERIOD: [Reducers.PERIOD, 'RESET_SELECTED_PERIOD'].join('/'),
};
